export default __webpack_public_path__ + "static/media/messagecenter-hover.362df070.svg";